var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgCoreDelegators = function SvgCoreDelegators(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.40426,
    cy: 3.40426,
    r: 3.40426,
    transform: "matrix(-1 0 0 1 15.6172 5.00024)",
    fill: "#FED700",
    stroke: "#FED700",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25537 16.8596C6.25537 16.1274 6.71567 15.4743 7.40524 15.228C10.5141 14.1177 13.9115 14.1177 17.0204 15.228C17.71 15.4743 18.1703 16.1274 18.1703 16.8596V17.9792C18.1703 18.9898 17.2752 19.7661 16.2748 19.6232L15.9412 19.5755C13.4682 19.2222 10.9575 19.2222 8.48442 19.5755L8.15087 19.6232C7.15044 19.7661 6.25537 18.9898 6.25537 17.9792V16.8596Z",
    fill: "#FED700",
    stroke: "#FED700",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3194 11.903C18.7966 11.903 19.9941 10.7055 19.9941 9.22824C19.9941 7.751 18.7966 6.55347 17.3194 6.55347",
    stroke: "#FED700",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2486 18.0053L20.5106 18.0427C21.2967 18.155 22 17.5451 22 16.7511V15.8714C22 15.2961 21.6383 14.7829 21.0965 14.5894C20.5561 14.3963 20.0045 14.246 19.4468 14.1384",
    stroke: "#FED700",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68063 11.903C5.2034 11.903 4.00586 10.7055 4.00586 9.22824C4.00586 7.751 5.2034 6.55347 6.68063 6.55347",
    stroke: "#FED700",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75143 18.0053L3.48935 18.0427C2.7033 18.155 2.00003 17.5451 2.00003 16.7511V15.8714C2.00003 15.2961 2.3617 14.7829 2.9035 14.5894C3.44395 14.3963 3.99549 14.246 4.55322 14.1384",
    stroke: "#FED700",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgCoreDelegators;